module.exports = __webpack_public_path__ + "static/media/square1.c72ae5f1.jpg";